export default __webpack_public_path__ + "assets/902c29c73db8734dfc8e32bb9af1dda9.svg";